import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { $getSelection } from "lexical";
import { useTheme } from "@mui/material/styles";
import { $patchStyleText } from "@lexical/selection";
import { MenuItem } from "../../../../../MenuItem/index.js";
import { Box } from "../../../../../Box/index.js";
import { Typography } from "../../../../../Typography/index.js";
const useColorsItems = (editor, activeColor)=>{
    const $ = c(17);
    const theme = useTheme();
    let t0;
    if ($[0] !== theme.tokens.colors.accent.text.error || $[1] !== theme.tokens.colors.accent.text.review || $[2] !== theme.tokens.colors.accent.text.success || $[3] !== theme.tokens.colors.accent.text.violet || $[4] !== theme.tokens.colors.accent.text.warning || $[5] !== theme.tokens.colors.original.brand.primary || $[6] !== theme.tokens.colors.text.light.primary || $[7] !== theme.tokens.colors.text.light.secondary) {
        t0 = {
            [theme.tokens.colors.text.light.primary]: "\u0427\u0435\u0440\u043D\u044B\u0439",
            [theme.tokens.colors.text.light.secondary]: "\u0421\u0435\u0440\u044B\u0439",
            [theme.tokens.colors.original.brand.primary]: "\u0421\u0438\u043D\u0438\u0439",
            [theme.tokens.colors.accent.text.success]: "\u0417\u0435\u043B\u0435\u043D\u044B\u0439",
            [theme.tokens.colors.accent.text.warning]: "\u041E\u0440\u0430\u043D\u0436\u0435\u0432\u044B\u0439",
            [theme.tokens.colors.accent.text.error]: "\u041A\u0440\u0430\u0441\u043D\u044B\u0439",
            [theme.tokens.colors.accent.text.review]: "\u0424\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u044B\u0439",
            [theme.tokens.colors.accent.text.violet]: "\u0421\u043B\u0438\u0432\u043E\u0432\u044B\u0439"
        };
        $[0] = theme.tokens.colors.accent.text.error;
        $[1] = theme.tokens.colors.accent.text.review;
        $[2] = theme.tokens.colors.accent.text.success;
        $[3] = theme.tokens.colors.accent.text.violet;
        $[4] = theme.tokens.colors.accent.text.warning;
        $[5] = theme.tokens.colors.original.brand.primary;
        $[6] = theme.tokens.colors.text.light.primary;
        $[7] = theme.tokens.colors.text.light.secondary;
        $[8] = t0;
    } else t0 = $[8];
    const ColorTypeToBlockName = t0;
    let t1;
    if ($[9] !== editor) {
        const applyStyleText = (styles)=>{
            editor.update(()=>{
                const selection = $getSelection();
                if (null !== selection) $patchStyleText(selection, styles);
            });
        };
        t1 = (value, type)=>{
            applyStyleText({
                [type]: value
            });
        };
        $[9] = editor;
        $[10] = t1;
    } else t1 = $[10];
    const onFontColorSelect = t1;
    let t2;
    if ($[11] !== ColorTypeToBlockName) {
        t2 = Object.entries(ColorTypeToBlockName);
        $[11] = ColorTypeToBlockName;
        $[12] = t2;
    } else t2 = $[12];
    let t3;
    if ($[13] !== activeColor || $[14] !== onFontColorSelect || $[15] !== t2) {
        t3 = t2.map((t4)=>{
            const [color, name] = t4;
            return /*#__PURE__*/ jsx(MenuItem, {
                onClick: ()=>onFontColorSelect(color, "color"),
                children: /*#__PURE__*/ jsxs(Box, {
                    display: "flex",
                    alignItems: "center",
                    gap: "8",
                    children: [
                        /*#__PURE__*/ jsx(Box, {
                            width: "16px",
                            height: "16px",
                            radius: "xs",
                            style: {
                                backgroundColor: color
                            }
                        }),
                        /*#__PURE__*/ jsx(Typography, {
                            variant: "body3",
                            color: activeColor === color ? "original.brand.primary" : "text.light.primary",
                            children: name
                        })
                    ]
                })
            }, color);
        });
        $[13] = activeColor;
        $[14] = onFontColorSelect;
        $[15] = t2;
        $[16] = t3;
    } else t3 = $[16];
    return t3;
};
export { useColorsItems };
